import operations from '~/helpers/device-operations';
import { lastResetType } from '~/helpers/fields-description';
import { BehaviorKey } from '~/interfaces/device.interface';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';
import { getServerNodeFields } from '~/models/helpers/network.function';
export class NXG extends Gateway {
    hasOperationImportData = false;
    hasOperationReset = false;
    last_reset_type?: string;
    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;
    behaviorFields: BehaviorKey[] = [
        'rf_statistics_enabled',
    ];

    get fieldLastResetType(): FieldObject | undefined {
        if (typeof this.last_reset_type !== 'undefined') {
            return lastResetType(this.last_reset_type);
        }
    }

    get deviceOperations() {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
            operations.recalibrateCO2({ callback: this.recalibrateCO2 }),
        ]);
    }

    getNetworkFields(): FieldObject[] {
        let fields = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }
        return fields;
    }
}

